<div class="makeMoov_header">
    <div class="teamMemberName">
      <span class="initials" [ngStyle]="{'background': color}">{{initials}}</span>
      <span class="nameText">{{firstName}} {{lastName}}</span>
    </div>
    <div class="wizardProgress">
      <div class="wizardSteps" *ngIf="wizardState==1">
        <span class="wizardStage"><span class="wizardStageNumber" [ngStyle]="{'background-color':'#1E2144'}">1</span><span class="wizardStageText">{{'moovWizard.firstStageName' | translate}}</span></span>
        <mat-divider class="wizargProgressDiv"></mat-divider>
        <span class="wizardStage"><span class="wizardStageNumber" [ngStyle]="{'background-color':'#00000033'}">2</span><span class="wizardStageText">{{'moovWizard.secondStageName' | translate}}</span></span>
      </div>
      <div class="wizardSteps" *ngIf="wizardState==2">
        <span class="wizardStage"><span class="wizardStageNumber" [ngStyle]="{'background-color':'#1E2144'}">1</span><span class="wizardStageText">{{'moovWizard.firstStageName' | translate}}</span></span>
        <mat-divider class="wizargProgressDiv"></mat-divider>
        <span class="wizardStage"><span class="wizardStageNumber" [ngStyle]="{'background-color':'#1E2144'}">2</span><span class="wizardStageText">{{'moovWizard.secondStageName' | translate}}</span></span>
     </div>
    </div>
    <div><button mat-raised-button class="closeButton" (click)="closeWizard()">{{"makeMoov.close" | translate}}</button></div>
</div>